function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { execute } from "./async";
export var BaseResources = /*#__PURE__*/function () {
  function BaseResources() {
    _classCallCheck(this, BaseResources);
    _defineProperty(this, "isLoading", void 0);
    _defineProperty(this, "resources", {});
    _defineProperty(this, "promise", void 0);
    this.isLoading = false;
  }
  _createClass(BaseResources, [{
    key: "use",
    value: function use(key) {
      var resource = this.getResource(key);
      if (!resource) {
        throw new Error("key ".concat(key, " unable load resource"));
        // return this.add(target)!;
      }
      return resource;
    }

    // add<R extends Resource<any>>(): R | null {
    //   const type = target.type;
    //   const factory = this.typeFactoryMap[type];
    //   if (!factory) {
    //     throw new Error(`resource type:${type} unable create`);
    //   }
    //   const resource = factory(target);
    //   if (this.addResource(target, resource)) {
    //     return resource as R;
    //   }
    //   return null;
    // }
  }, {
    key: "remove",
    value: function remove(key) {
      var resource = this.resources[key];
      resource.destroy();
      delete this.resources[key];
    }
  }, {
    key: "load",
    value: function load() {
      var _this = this;
      if (this.isLoading) {
        return this.promise;
      }
      this.isLoading = true;
      var queue = [];
      var _loop = function _loop() {
        var resource = _this.resources[name];
        queue.push(function () {
          return resource.load();
        });
      };
      for (var name in this.resources) {
        _loop();
      }
      return this.promise = execute(queue, {
        concurrency: 3
      }).finally(function () {
        _this.isLoading = false;
        _this.promise = undefined;
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.isLoading = false;
      for (var name in this.resources) {
        this.remove(name);
      }
    }
  }, {
    key: "addResource",
    value: function addResource(uri, resource) {
      if (this.resources[uri]) {
        return false;
      }
      this.resources[uri] = resource;
      return this;
    }
  }, {
    key: "getResource",
    value: function getResource(uri) {
      return this.resources[uri];
    }
  }]);
  return BaseResources;
}();